import * as THREE from "three";

export const _Y_AXIS = new THREE.Vector3(0, 1, 0); // Reusable Y axis for quaternion operations
